<template>
    <div class="editProfile">
        <van-form
            ref="validateForm"
            validate-first
            input-align="right"
            :show-error="false"
            :show-error-message="false"
        >
            <van-field
                required
                autosize
                v-model.trim="userInfo.name"
                label="真实姓名"
                placeholder="请输入真实姓名"
                :rules="[{ required: true, message: '请输入真实姓名' }]"
            />
            <!-- 党政干部不需要身份认证 -->
            <van-field
                v-if="!isGB"
                v-model.trim="userInfo.idCardNo"
                label="身份证号"
                readonly
            >
                <template v-if="!userInfo.idCardNo" #button>
                    <van-button
                        size="small"
                        type="primary"
                        color="#1972ff"
                        @click="toIdentify"
                    >前往身份认证</van-button
                    >
                </template>
            </van-field>
            <van-field label="性别" placeholder="请选择性别" key="gender">
                <template #input>
                    <van-radio-group v-model="userInfo.gender" direction="horizontal">
                        <van-radio :name="1">男</van-radio>
                        <van-radio :name="2">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <!-- 出生日期 -->
            <van-field
                readonly
                clickable
                right-icon="arrow"
                :value="userInfo.birthday && userInfo.birthday.substring(0, 11)"
                label="出生日期"
                placeholder="请选择出生日期"
                @click="showBirthdayPicker = true"
            />
            <van-popup v-model="showBirthdayPicker" round position="bottom">
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    title="请选择出生日期"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="birthdayOnConfirm"
                    @cancel="showBirthdayPicker = false"
                />
            </van-popup>

            <!-- 党政干部 -->
            <template v-if="isGB">
                <!-- 输入所在地区 -->
                <van-field
                    required
                    disabled=""
                    v-model.trim="yjInfo.gbRegion"
                    label="所在地区"
                    placeholder="请输入所在地区"
                    :rules="[{ required: true, message: '请输入所在地区' }]"
                />
                <!-- 输入所属企业 -->
                <van-field
                    required
                    v-model.trim="yjInfo.gbEmployer"
                    label="所属企业"
                    placeholder="请输入所属企业"
                    :rules="[{ required: true, message: '请输入所属企业' }]"
                />
                <!-- 输入职务 -->
                <van-field
                    required
                    v-model.trim="yjInfo.position"
                    label="职务"
                    placeholder="请输入职务"
                    :rules="[{ required: true, message: '请输入职务' }]"
                />
            </template>

            <!-- 普通员工 -->
            <template v-else>
                <!-- 选择身份 -->
                <van-field
                    label="身份"
                    required
                    rows="1"
                    autosize
                    type="textarea"
                    v-model="identity"
                    readonly
                    @click="showIdentity = true"
                    :rules="[{ required: true, message: '请选择身份' }]"
                    placeholder="请选择身份"
                />
                <van-popup v-model="showIdentity" round position="bottom">
                    <van-cascader
                        v-model="cascaderValue"
                        title="请选择身份"
                        :options="identityList"
                        @close="showIdentity = false"
                        @finish="onSelectIdentity"
                        active-color="#1972ff"
                    />
                </van-popup>
                <!-- 选择所在单位 -->
                <van-field
                    required
                    label="所属单位"
                    v-model="branch"
                    readonly
                    @click="showBranch = true"
                    :rules="[{ required: true, message: '请选择所属单位' }]"
                    placeholder="请选择所属单位"
                />
                <van-popup
                    v-model="showBranch"
                    round
                    position="bottom"
                    @close="handleCloseBranchList"
                >
                    <van-search
                        v-model.trim="searchValue"
                        input-align="left"
                        placeholder="请输入搜索关键词"
                        @search="onSearch"
                        @input="onInput"
                    />
                    <van-picker
                        show-toolbar
                        :columns="branchList"
                        :loading="loading"
                        @cancel="handlePickerCancel"
                        @confirm="handlePickerConfirm"
                    />
                </van-popup>
            </template>
            <div class="handle_btn">
                <van-button
                    round
                    block
                    plain
                    type="info"
                    class="cancel_btn"
                    @click="cancelHandle"
                >取消</van-button
                >
                <van-button round block type="info" class="save_btn" @click="saveHandle"
                >保存</van-button
                >
            </div>
        </van-form>
    </div>
</template>

<script>
const isPhone =
    /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
import { identityList } from "./assets/fm_data";
export default {
    name: "feimeiUserInfo",
    data() {
        return {
            searchValue: "",
            loading: false,
            showBranch: false,
            showIdentity: false,
            identityList,
            branchList: [],
            userInfo: {
                name: "",
                idCardNo: "",
                gender: "",
                birthday: "",
            },
            yjInfo: {
                userFirstIdentity: null, //一级身份
                userIdentity: null, //二级身份
                position: "", // 职务
                branchId: "", // 所属企业(员工)
                gbRegion: "", // 所在地区
                gbEmployer: "", // 单位
            },
            branch: "",
            identity: "",
            cascaderValue: "",
            showBirthdayPicker: false,
            minDate: new Date(1900, 0, 1),
            maxDate: new Date(),
            currentDate: new Date(2000, 0, 1),
            isGB: true, //是否为党政干部
        };
    },
    mounted() {
        this.getData();
        this.findByCurr();
        // 获取企业机构
        this.findEntBranch({ name: null });
    },
    methods: {
        handleCloseBranchList() {
            this.loading = false;
            this.searchValue = "";
            this.findEntBranch({ name: null });
        },
        handlePickerConfirm(val) {
            this.yjInfo.branchId = val.value;
            this.branch = val.text;
            this.showBranch = false;
        },
        handlePickerCancel() {
            this.showBranch = false;
        },
        onInput(val) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.findEntBranch({ name: val });
            }, 200);
        },
        onSearch(val) {
            this.findEntBranch({
                name: val,
            });
        },
        findByCurr() {
            this.$api.sdyjFmUser.findByCurr().then((res) => {
                if (res.success && res.data) {
                    if (res.data.userFirstIdentity) {
                        this.identity =
                            res.data.userFirstIdentity + "/" + res.data.userIdentity;
                        // this.isGB = false
                    }
                    if (res.data.position == "" || !res.data.position) {
                        this.isGB = false;
                    } else {
                        this.isGB = true;
                    }
                    console.log("this.isGB", this.isGB);
                    for (let key in this.yjInfo) {
                        this.yjInfo[key] = res.data[key];
                    }
                    // 所属地区回显
                    this.branch = res.data.entName;
                    if (res.data.city) {
                        this.yjInfo.gbRegion =
                            res.data.city + "-" + res.data.county + "-" + res.data.street;
                    }
                }
            });
        },
        onSelectIdentity({ selectedOptions }) {
            this.showIdentity = false;
            this.identity = selectedOptions.map((option) => option.text).join("/");
            this.yjInfo.userFirstIdentity = selectedOptions[0].value;
            this.yjInfo.userIdentity = selectedOptions[1].value;
        },
        findEntBranch(params) {
            this.loading = true;
            this.branchList = [];
            this.$api.fmBranch.findEntBranch(params).then((res) => {
                this.loading = false;
                if (res.success && res.data) {
                    let formatData = res.data.map((item) => {
                        return {
                            text: item.name,
                            value: item.id,
                        };
                    });
                    this.branchList = Object.freeze(formatData);
                }
            });
        },
        getData() {
            this.$api.user.findUser().then((res) => {
                if (res.code == 0 && res.success) {
                    this.userInfo = Object.assign({}, this.userInfo, res.data);
                    this.currentDate = new Date(res.data.birthday);
                }
            });
        },
        toIdentify() {
            this.$router.push("/idcard");
        },
        //picker 选择框确定
        birthdayOnConfirm(date) {
            console.log(date);
            this.userInfo.birthday = this.formatime(date);
            this.showBirthdayPicker = false;
        },
        // 格式化时间
        formatime(dayCount) {
            const createtime = new Date(dayCount);
            const year = createtime.getFullYear();
            let month = createtime.getMonth() + 1;
            let day = createtime.getDate(); // 几号
            month = month < 10 ? "0" + month : month;
            day = day < 10 ? "0" + day : day;
            return year + "-" + month + "-" + day + " 00:00:00";
        },
        cancelHandle() {
            this.$router.back();
        },
        //保存
        saveHandle() {
            this.$refs.validateForm
                .validate()
                .then(() => {
                    // console.log(this.userInfo);
                    this.$api.user.updateUser(this.userInfo).then((res) => {});
                    this.saveYjInfo();
                })
                .catch((error) => {
                    console.log(error);
                    this.$toast({
                        message: error[0].message,
                        className: "errorTY",
                    });
                });
        },
        saveYjInfo() {
            this.$api.sdyjFmUser.updateSdyjWhpUser(this.yjInfo).then((res) => {
                if (res.success) {
                    this.$toast({
                        message: "保存成功",
                    });
                    if (this.from === "/yj_m_register") {
                        this.$router.push("/learning");
                    } else {
                        this.$router.back();
                    }
                }
            });
        },
    },
};
</script>

<style lang="stylus" scoped>
.editProfile {
    // height: 100vh;
    background: #f5f6fa;
    overflow: auto;

    .photo_box {
        position: relative;
        width: 200px;
        height: 280px;
        border-radius: 10px;
        overflow: hidden;
    }

    .my_photo {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;

        img {
            width: 100%;
            height: 100%;
        }

        .tips {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 200px;
            height: 56px;
            background-color: rgba(0, 0, 0, 0.4);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .re_uploadImg {
            width: 112px;
            height: 28px;
        }
    }

    .file_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #f7f8fa;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .file {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    .space {
        height: 16px;
        width: 100%;
    }

    .handle_btn {
        width: 750px;
        height: 112px;
        background: #FFFFFF;
        box-shadow: 0px 1px 0px 0px #EAEAEA;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 48px;

        .cancel_btn {
            width: 332px;
            height: 88px;
            border-radius: 50px;
            border: 1px solid #1972FF;
            margin-right: 26px;
            color: #1972FF;
            font-size: 32px;
        }

        .save_btn {
            width: 332px;
            height: 88px;
            background: #1972FF;
            border-radius: 50px;
            font-size: 32px;
            color: #FFFFFF;
        }
    }

    .van-action-sheet__header {
        font-weight: 600;
    }
}
</style>
<style lang="stylus">
.editProfile {
    .van-uploader__wrapper {
        width: 100%;
        height: 100%;

        .van-uploader__upload {
            width: 100%;
            height: 100%;
            margin: 0;
        }
    }

    .van-cell {
        min-height: 2.773rem;
        padding-left: 1.2rem;
        padding-right: 0.8rem;
        display: flex;
        align-items: center;
    }

    .van-cell--required::before {
        left: 0.8rem;
    }

    .van-cell.photo_wrap {
        align-items: flex-start;
        padding-top: 0.96rem;
        padding-bottom: 1.066rem;
    }

    .van-cell.block_field {
        display: block;
        padding-top: 0.8rem;
        padding-bottom: 0.9rem;

        .radio_group {
            margin-top: 0.9rem;
        }
    }
}

.van-toast.errorTY {
    background-color: #FF5758 !important;
}
</style>
